import { clsx } from "clsx";

export default function IconClose({ className }: { className?: string }) {
  return (
    <svg
      className={clsx("", className)}
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.78784 7.97369L7.35034 9.38444L14.6316 16.5302L7.35034 23.676L8.78784 25.0868L16.0691 17.941L23.3503 25.0868L24.7878 23.676L17.5066 16.5302L24.7878 9.38444L23.3503 7.97369L16.0691 15.1195L8.78784 7.97369Z"
        fill="currentColor"
      />
    </svg>
  );
}
